import { Badge } from "@/components/Dumb/Molecules/Badge/Badge";
import styled from "styled-components";

export const StyledBadge = styled(Badge)`
    position: initial;
    width: fit-content;
    height: 20px;
`
